import TrustpilotReviews from "./src/trustpilot-reviews"

export default TrustpilotReviews